export default __webpack_public_path__ + "static/media/skull_web.dc0ad164.png";